import React from 'react';
import GameListHeader from '@/pages/games/list/GameListHeader';
import { GamesCategories } from '@/models/game-category.type';
import { GameCardVM } from '@/models/vm/game-card-vm.model';
import EmptyGamesPlaceholder from '@/pages/games/EmptyGamesPlaceholder';
import GamesInfiniteGrid from '@/pages/games/list/GamesInfiniteGrid';

type CategoryPageContentProps = {
  header?: string;
  subheader?: string;
  category: GamesCategories;
  games: GameCardVM[];
  loading: boolean;
};

const CategoryPageContent = ({
  header,
  subheader,
  category,
  games,
  loading,
}: CategoryPageContentProps): JSX.Element => {
  return (
    <section className="py-6 md:py-8 space-y-6 md:space-y-10 max-w-[1400px] mx-auto px-[16px] 2xl:px-0">
      {header && (
        <GameListHeader
          header={header}
          subheader={subheader}
          games={games}
          count={games.length}
          gamesLoading={loading}
        />
      )}
      {games && games.length > 0 ? (
        <GamesInfiniteGrid games={games} category={category} gamesLoading={loading} />
      ) : (
        <EmptyGamesPlaceholder category={category} />
      )}
    </section>
  );
};

export default CategoryPageContent;
